/* @flow */
import React from 'react'
import { cropableImageModalActionMaker } from '@website/components/ActionMakers'

import {
  changeTitle,
  changeParagraph,
  changeMockupColor,
  makeMockupLight,
  makeMockupDark,
  changeTitleAlignment,
  changeParagraphAlignment
} from '@website/components/CommonActions'

import MockupColorSwitcher from '@website/common/components/MockupColorSwitcher'

export default dispatcher => {
  const _changeTitle = (title: string) => dispatcher(changeTitle(title))

  const _changeParagraph = (paragraph: string) =>
    dispatcher(changeParagraph(paragraph))

  const _changeTitleAlignment = alignment => {
    dispatcher(changeTitleAlignment(alignment))
  }

  const _changeParagraphAlignment = alignment => {
    dispatcher(changeParagraphAlignment(alignment))
  }

  const _mockupActions = ({ mockupColor, imageUrl }) => [
    ...cropableImageModalActionMaker(dispatcher)({
      keyForSizes: 'header11MockupSizes',
      showRemove: false,
      imageUrl
    }),
    {
      renderer: () => (
        <MockupColorSwitcher
          onChoose={() => dispatcher(changeMockupColor())}
          onFirstOptionSelect={() => dispatcher(makeMockupLight())}
          onSecondOptionSelect={() => dispatcher(makeMockupDark())}
          isSecondOptionSelected={mockupColor === 'dark'}
        />
      )
    }
  ]

  return {
    changeTitle: _changeTitle,
    changeParagraph: _changeParagraph,
    mockupActions: _mockupActions,
    changeTitleAlignment: _changeTitleAlignment,
    changeParagraphAlignment: _changeParagraphAlignment
  }
}
